jQuery(document).ready(function($) {
    $('.-hero').unslider({
        autoplay: true,
        arrows: false 
    });

    $('.burger').on('click', function(){
        $('.nav ul').toggleClass('show');
    });
});